export interface ICRUD<T> {
    result?: T;
}

export enum RequestStatus {
    Active = "ACTIVE",
    Error = "ERROR",
    Idle = "IDLE",
}

export interface IQuery<T> extends ICRUD<T> {
    queryStatus: RequestStatus;
    queryError?: Error;
}

export interface IMutate<T> extends ICRUD<T> {
    mutateStatus: RequestStatus;
    mutateError?: Error;
}
